<template>
  <div class="row comments-list" v-if="showComments">
    <div class="col-md-6 col-12">
      <div class="comments-title-container pb-2">
        <h6>Comments</h6>
      </div>

      <ul class="px-0">
        <li v-for="(comment, key) in commentsList" :key="key">
          <div class="py-2 mb-2">
            <!-- root comment -->
            <knowledge-article-comment :comment-data="comment" />
            <!-- replies -->
            <div class="reply-thread-wrapper d-flex flex-row pt-2">
              <div
                v-if="commentHasChildren(comment)"
                class="reply-arrow-wrapper mr-3"
              >
                <img class="reply-arrow-icon" src="./../../assets/reply-arrow.svg" />
              </div>
              <ul class="px-0">
                <li
                  v-for="(childComment, key) in comment.formattedChildComments"
                  :key="key"
                  class="pb-2"
                >
                  <knowledge-article-comment
                    :comment-data="childComment"
                    :is-admin="true"
                  />
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import KnowledgeArticleComment from "./KnowledgeArticleComment";
import { mapGetters } from "vuex";

export default {
  name: "knowledge-article-comments",
  props: ["articleComments"],
  components: {
    KnowledgeArticleComment,
  },
  computed: {
    ...mapGetters(["platformCategories", "user"]),
    showComments() {
      let userHasPermission = this.checkUserHasKnowledgeFeedbackPermissions();
      return userHasPermission && this.commentsList && this.commentsList.length > 0;
    },
    commentsList() {
      return this.constructAllCommentThreads();
    }
  },
  methods: {
    checkUserHasKnowledgeFeedbackPermissions() {
      if (this.user.authorities.indexOf("EMPLOYEE_HUB_ADMIN") !== -1) return true;
      let userHasPermission = false;
      let currentPlatformCategory = this.$route.params.platformCategory;
      let category = this.platformCategories.find(category => category.alias === currentPlatformCategory)  
      
      // check feedback visibility permissions for current platform category
      // as configured in manage-eh-platforms application
      if (category.knowledgeArticleFeedbackPermissions && category.knowledgeArticleFeedbackPermissions.length > 0) {

        let feedbackPermissionsList = category.knowledgeArticleFeedbackPermissions.trim().split(',');
        let userAuthorities = this.user.authorities;
        feedbackPermissionsList.forEach(permission => {
          if (userAuthorities.includes(permission)) userHasPermission = true
        })
      } 
      
      // display feedback by default if no configuration has been made
      else {
        userHasPermission = true;
      }

      return userHasPermission;
    },
    constructAllCommentThreads() {
      let formattedComments = this.formatCommentsList(this.articleComments);
      
      // a comment is a root comment if it has no parent
      let rootComments = formattedComments.filter(
        (comment) => !comment["parent_comment"]
      );
      
      rootComments.forEach((rootComment) => {
        rootComment.formattedChildComments = this.constructCommentThread(
          formattedComments,
          rootComment["sys_id"]
        );
      });
      return rootComments;
    },

    constructCommentThread(commentsList, parentId) {
      if (!(commentsList && commentsList.length > 0)) return [];
      let childCommentsList = commentsList.filter((comment) => {
        return comment["parent_comment"] && comment["parent_comment"].value === parentId;
      });
      return this.formatCommentsList(childCommentsList, true);
    },

    formatCommentsList(commentsList, sortOldestToNewest = false) {
      let comments = commentsList.filter((comment) => comment.comments);
      comments.sort((a, b) => {
        return (
          new Date(b["sys_created_on"]).getTime() -
          new Date(a["sys_created_on"]).getTime()
        );
      });

      if (sortOldestToNewest) comments.reverse();
      return comments;
    },
    commentHasChildren(comment) {
      return (
        comment.formattedChildComments &&
        comment.formattedChildComments.length > 0
      );
    },
  },
};
</script>

<style scoped>
.comments-list h6 {
  margin-bottom: 0;
  font-size: 20px;
}
.comments-list li {
  list-style: none;
}
.comments-list .comments-author-time {
  font-weight: bold;
  color: #000000;
}
.comments-list .comments-title-container {
  color: #000000;
  font-weight: bold;
}

.reply-arrow-icon {
  color: #64788d;
}
.reply-thread-wrapper {
  margin: 0 0 0 43px;
}
</style>



// WEBPACK FOOTER //
// src/components/knowledge-article/KnowledgeArticleComments.vue